import { render } from "./StaffSearch.vue?vue&type=template&id=7fb0a8b8&ts=true"
import script from "./StaffSearch.vue?vue&type=script&lang=ts"
export * from "./StaffSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__